<template>
  <div class="groovemail-form-preset">
    <!-- Loader -->
    <portal to="loaderTarget">
      <div class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99" v-if="isLoading">
        <gd-loader :label="$t('frontend_loading')"/>
      </div>
    </portal>
    
    <div
      class="flex justify-center rounded"
    >
      <form 
        v-if="formDetails.style"
        id="saveform"
        class="rounded-md w-full form-wrapper relative"
        :style="
            '--gp-bg-front-color:' + formDetails.style.styles.form.backgroundPatternFrontColor + ';' +
            '--gp-bg-front-alpha-color:' + (formDetails.style.styles.form.backgroundPatternFrontColor??'').replace('1)', '0.333)') + ';' +
            '--gp-bg-back-color:' + formDetails.style.styles.form.backgroundPatternBackColor + ';' +
            '--gp-bg-spacing:' + formDetails.style.styles.form.backgroundPatternSpacing + 'px;' +
            '--gp-bg-opacity:' + ((formDetails.style.styles.form.backgroundPatternOpacity??100)/100)+ ';' +
            'background-color:' + formDetails.style.styles.form.backgroundColor + ';' +
            'background-blur:' + (formDetails.style.styles.form.backgroundBlur??0) + 'px;' +
            'background:' + formDetails.style.styles.form.backgroundColor + ';' +
            'color:' + formDetails.style.styles.form.color + ';' +
            'padding: ' + formDetails.style.styles.form.padding.join('px ') + 'px;' +
            'margin: ' + formDetails.style.styles.form.margin.join('px ') + 'px;' +
            'border-width:' + formDetails.style.styles.form.border?.width.join('px ') + 'px;' +
            'border-radius:' + formDetails.style.styles.form.border?.radius.join('px ') + 'px;' +
            'border-color:' + formDetails.style.styles.form.border?.color.join(' ') + ';' +
            'border-style:' + formDetails.style.styles.form.border?.style.join(' ') + ';' +
            'background-size:' + formDetails.style.styles.form.backgroundSize + ';' +
            'background-position:' + formDetails.style.styles.form.backgroundPosition + ';' +
            'background-repeat:' + formDetails.style.styles.form.backgroundRepeat + ';' +
            'background-image:' + (formDetails.style.styles.form.backgroundImage == null ? 'none' : formDetails.style.styles.form.backgroundImage ) + ';' +
            formDetails.style.styles.form.customStyles ?? ''
        "
      >
        <input type="hidden" name="formid" :value="this.formid" />
        <input type="hidden" name="ip_address" :value="this.ipaddress" />
        <input type="hidden" name="appUrl" :value="this.appUrl" />
        <input type="hidden" name="form_submit_type" value="js_form" />
        <input type="hidden" :name="hiddenKey" value="" />

        <div
          v-if="formDetails.form_heading && !form_fields_info.headings_v2"
          :style="
              'font-family:' + (formDetails.style.styles.heading.text.fontFamily || '') + ';' +
              'text-shadow:' + (formDetails.style.styles.heading.text.textShadow || '') + ';' +
              'font-size:' + formDetails.style.styles.heading.text.fontSize + 'px;' +
              'text-align:' + formDetails.style.styles.heading.text.textAlign + ';' +
              'font-style:' + (formDetails.style.styles.heading.text.fontStyle || '') + ';' +
              'font-weight:' + (formDetails.style.styles.heading.text.fontWeight || '') + ';' +
              'letter-spacing:' + (formDetails.style.styles.heading.text.letterSpacing || '') + ';' +
              'line-height:' + (formDetails.style.styles.heading.text.lineHeight || '') + ';' +
              '-webkit-text-stroke-width:' + (formDetails.style.styles.heading.text.textStrokeWidth || '') + ';' +
              '-webkit-text-stroke-color:' + (formDetails.style.styles.heading.text.textStrokeColor || '') + ';' +
              'text-decoration-line:' + (formDetails.style.styles.heading.text.textDecorationLine || '') + ';' +
              'padding: ' + formDetails.style.styles.heading.padding.join('px ') + 'px;' +
              'margin: ' + formDetails.style.styles.heading.margin.join('px ') + 'px;' +
              'color:' + formDetails.style.styles.heading.text.color + ';' +
              formDetails.style.styles.heading.customStyles ?? ''
          "
          class="text-xl font-bold outline-none text-center relative"
        >
          {{ formDetails.form_heading }}
        </div>
        <div
          v-if="formDetails.form_sub_heading && !form_fields_info.headings_v2"
          :style="
              'font-family:' + (formDetails.style.styles.subheading.text.fontFamily || '') + ';' +
              'text-shadow:' + (formDetails.style.styles.subheading.text.textShadow || '') + ';' +
              'font-size:' + formDetails.style.styles.subheading.text.fontSize + 'px;' +
              'text-align:' + formDetails.style.styles.subheading.text.textAlign + ';' +
              'font-style:' + (formDetails.style.styles.subheading.text.fontStyle || '') + ';' +
              'font-weight:' + (formDetails.style.styles.subheading.text.fontWeight || '') + ';' +
              'letter-spacing:' + (formDetails.style.styles.subheading.text.letterSpacing || '') + ';' +
              'line-height:' + (formDetails.style.styles.subheading.text.lineHeight || '') + ';' +
              '-webkit-text-stroke-width:' + (formDetails.style.styles.subheading.text.textStrokeWidth || '') + ';' +
              '-webkit-text-stroke-color:' + (formDetails.style.styles.subheading.text.textStrokeColor || '') + ';' +
              'text-decoration-line:' + (formDetails.style.styles.subheading.text.textDecorationLine || '') + ';' +
              'padding: ' + formDetails.style.styles.subheading.padding.join('px ') + 'px;' +
              'margin: ' + formDetails.style.styles.subheading.margin.join('px ') + 'px;' +
              'color:' + formDetails.style.styles.subheading.text.color + ';' +
              formDetails.style.styles.subheading.customStyles ?? ''
          "
          class="text-sm mt-1 mb-10 outline-none text-center relative"
        >
          {{ formDetails.form_sub_heading }}
        </div>
        <div class="mt-10 relative">
        <div
          class="w-full flex space-x-4"
          v-for="(row, indexRow) in rows"
          :key="indexRow"
        >
          <div
            v-for="(column, indexCol) in row"
            :key="indexCol"
            :class="{
              'w-full': column.width==100,
              'w-1/2': column.width==50,
              'w-1/3': column.width==33,
              'sm:flex-row flex': form_fields_info.layout_type == 'horizontal',
              'sm:flex-col flex': form_fields_info.layout_type != 'horizontal',
            }"
            class="flex-col formColumn2"
          >
            <div
              v-for="(element, mainindex) in column.fields"
              :key="mainindex"
              class="w-full"
              :style="'background-color:' + formDetails.style.styles.color"
            >
              <div
                v-if="['paragraph', 'heading', 'subheading'].includes(element.type)"
              >
                <div
                  class="my-1"
                  :style="
                  'font-family:' + (getStyle(element).text.fontFamily || '') + ';' +
                  'text-shadow:' + (getStyle(element).text.textShadow || '') + ';' +
                  'font-size:' + getStyle(element).text.fontSize + 'px;' +
                  'text-align:' + getStyle(element).text.textAlign + ';' +
                  'font-style:' + (getStyle(element).text.fontStyle || '') + ';' +
                  'font-weight:' + (getStyle(element).text.fontWeight || '') + ';' +
                  'letter-spacing:' + (getStyle(element).text.letterSpacing || '') + ';' +
                  'line-height:' + (getStyle(element).text.lineHeight || '') + ';' +
                  '-webkit-text-stroke-width:' + (getStyle(element).text.textStrokeWidth || '') + ';' +
                  '-webkit-text-stroke-color:' + (getStyle(element).text.textStrokeColor || '') + ';' +
                  'text-decoration-line:' + (getStyle(element).text.textDecorationLine || '') + ';' +
                  'color:' + getStyle(element).text.color + ';' +
                  'padding:' + (getStyle(element).padding ? getStyle(element).padding.join('px ') + 'px;' : ';') +
                  'margin:' + (getStyle(element).margin ? getStyle(element).margin.join('px ') + 'px;' : ';') +
                  getStyle(element).customStyles ?? ''
                  "
                  v-html="element.placeholder"
                ></div>
              </div>
              <div
                v-if="element.type === 'accept'"
              >
                <div
                  class="flex"
                  :style="
                    'padding: ' + getStyle(element).padding.join('px ') + 'px;' +
                    'margin: ' + getStyle(element).margin.join('px ') + 'px;' +
                    'font-family:' + (getStyle(element).text.fontFamily || '') + ';' +
                    'text-shadow:' + (getStyle(element).text.textShadow || '') + ';' +
                    'font-size:' + getStyle(element).text.fontSize + 'px;' +
                    'justify-content: ' + getStyle(element).text.textAlign + ';' +
                    'font-style:' + (getStyle(element).text.fontStyle || '') + ';' +
                    'font-weight:' + (getStyle(element).text.fontWeight || '') + ';' +
                    'letter-spacing:' + (getStyle(element).text.letterSpacing || '') + ';' +
                    'line-height:' + (getStyle(element).text.lineHeight || '') + ';' +
                    '-webkit-text-stroke-width:' + (getStyle(element).text.textStrokeWidth || '') + ';' +
                    '-webkit-text-stroke-color:' + (getStyle(element).text.textStrokeColor || '') + ';' +
                    'text-decoration-line:' + (getStyle(element).text.textDecorationLine || '') + ';' +
                    'color:' + getStyle(element).text.color + ';' +
                    getStyle(element).customStyles ?? ''
                  "
                >
                  <label class="container text-sm" style="display:inline-box; width:auto">
                    {{ element.placeholder }}
                    <input
                      type="checkbox"
                      :id="
                        element.fieldtype === 'standard'
                          ? element.name + '[]_' + formid
                          : element.identifier + '[]_' + formid
                      "
                      @change="formAltered"
                      @input="formAltered"
                      class="mr-10"
                      :required="
                        element.mandatory === true ||
                        element.mandatory === 1 ||
                        element.mandatory === 'true'
                          ? true
                          : false
                      "
                      :name="
                        element.fieldtype === 'standard'
                          ? element.name + '[]'
                          : element.identifier + '[]'
                      "
                    />
                    <span
                      class="checkmark"
                      :style="
                        '--form-style-color:' + getStyle(element).iconColor + ';' +
                        '--form-style-background:' + getStyle(element).backgroundColor"
                    ></span>
                  </label>
                </div>
              </div>
              <div
                v-if="(element.type === 'textbox' || element.type === 'datepicker') && element.name != 'phone_number'"
                class="flex flex-col mb-4 relative"
                :style="
                  'margin: ' + getStyle(element).margin.join('px ') + 'px;' +
                  'color:' + getStyle(element).text.color + ';'
                "
              >
                <p
                  class="font-semibold text-sm mb-2"
                  v-if="!form_fields_info.hide_labels"
                  :style="
                    'text-align: ' + getStyle(element).text.textAlign + ';' +
                    'color: ' + getStyle(element).labelColor + ';'
                  "
                >
                  {{ element.placeholder }}
                  <span
                    v-if="
                      element.mandatory === true ||
                      element.mandatory === 1 ||
                      element.mandatory === 'true'
                    "
                    class="text-red font-bold"
                    >*</span
                  >
                </p>
                <div class="w-full flex">
                  <div
                    class="
                      w-full relative border border-solid rounded-lg text-dark flex
                      text-sm border-none text-grey-600 border-grey-200
                    "
                    :id="
                      element.fieldtype === 'standard'
                        ? element.name + '_' + formid
                        : element.identifier + '_' + formid
                    "
                    v-if="element.type === 'datepicker'"
                  >
                    <div
                      class="absolute z-50 pointer-events-none"
                      style="right: 15px; top: 50%; transform: translateY(-50%);"
                    >
                      <CalenderIcon class="text-grey-500 h-5 w-5"/>
                    </div>
                    <DateTimePicker
                      :required="
                        element.mandatory === true ||
                        element.mandatory === 1 ||
                        element.mandatory === 'true'
                          ? true
                          : false
                      "
                      :name="
                        element.fieldtype === 'standard'
                          ? element.name
                          : element.identifier
                      "
                      class="px-0 h-full"
                      variant="custom"
                      picker="date"
                      :maxDatetime="new Date().toISOString()"
                      @input="formAltered"
                      @chnage="formAltered"
                      :placeholder="element.placeholder"
                      :inputStyle="
                        'background:' + getStyle(element).backgroundColor + ';' +
                        'box-shadow:' + (getStyle(element).boxShadow ?? '') + ';' +

                        '--form-style-placeholder-color:' + getStyle(element).placeholderColor + ';' +
                        'font-family:' + (getStyle(element).text.fontFamily || '') + ';' +
                        'text-shadow:' + (getStyle(element).text.textShadow || '') + ';' +
                        'font-size:' + getStyle(element).text.fontSize + 'px;' +
                        'text-align:' + getStyle(element).text.textAlign + ';' +
                        'font-style:' + (getStyle(element).text.fontStyle || '') + ';' +
                        'font-weight:' + (getStyle(element).text.fontWeight || '') + ';' +
                        'letter-spacing:' + (getStyle(element).text.letterSpacing || '') + ';' +
                        'line-height:' + (getStyle(element).text.lineHeight || '') + ';' +
                        '-webkit-text-stroke-width:' + (getStyle(element).text.textStrokeWidth || '') + ';' +
                        '-webkit-text-stroke-color:' + (getStyle(element).text.textStrokeColor || '') + ';' +
                        'text-decoration-line:' + (getStyle(element).text.textDecorationLine || '') + ';' +
                        'color:' + getStyle(element).text.color + ';' +

                        'padding: ' + getStyle(element).padding.join('px ') + 'px;' +
                        'height:auto;' +
                        'border-width:' + getStyle(element).border?.width.join('px ') + 'px;' +
                        'border-radius:' + getStyle(element).border?.radius.join('px ') + 'px;' +
                        'border-color:' + getStyle(element).border?.color.join(' ') + ';' +
                        'border-style:' + getStyle(element).border?.style.join(' ') + ';' +
                        getStyle(element).customStyles ?? ''
                      "
                    />
                  </div>
                  <input
                    :id="
                      element.fieldtype === 'standard'
                        ? element.name + '_' + formid
                        : element.identifier + '_' + formid
                    "
                    :type="
                      element.name === 'email'
                        ? 'email'
                        : 'text'"
                    v-if="element.type !== 'datepicker'"
                    :placeholder="element.placeholder"
                    class="rounded-lg w-full"
                    :required="
                      element.mandatory === true ||
                      element.mandatory === 1 ||
                      element.mandatory === 'true'
                        ? true
                        : false
                    "
                    :name="
                      element.fieldtype === 'standard'
                        ? element.name
                        : element.identifier
                    "
                    @change="enteredText($event)"
                    :style="
                        'background:' + getStyle(element).backgroundColor + ';' +
                        'box-shadow:' + (getStyle(element).boxShadow ?? '') + ';' +
                        '--form-style-placeholder-color:' + getStyle(element).placeholderColor + ';' +
                        'font-family:' + (getStyle(element).text.fontFamily || '') + ';' +
                        'text-shadow:' + (getStyle(element).text.textShadow || '') + ';' +
                        'font-size:' + getStyle(element).text.fontSize + 'px;' +
                        'text-align:' + getStyle(element).text.textAlign + ';' +
                        'font-style:' + (getStyle(element).text.fontStyle || '') + ';' +
                        'font-weight:' + (getStyle(element).text.fontWeight || '') + ';' +
                        'letter-spacing:' + (getStyle(element).text.letterSpacing || '') + ';' +
                        'line-height:' + (getStyle(element).text.lineHeight || '') + ';' +
                        '-webkit-text-stroke-width:' + (getStyle(element).text.textStrokeWidth || '') + ';' +
                        '-webkit-text-stroke-color:' + (getStyle(element).text.textStrokeColor || '') + ';' +
                        'text-decoration-line:' + (getStyle(element).text.textDecorationLine || '') + ';' +
                        'color:' + getStyle(element).text.color + ';' +
                        'padding: ' + getStyle(element).padding.join('px ') + 'px;' +
                        'height:auto;' +
                        'border-width:' + getStyle(element).border?.width.join('px ') + 'px;' +
                        'border-radius:' + getStyle(element).border?.radius.join('px ') + 'px;' +
                        'border-color:' + getStyle(element).border?.color.join(' ') + ';' +
                        'border-style:' + getStyle(element).border?.style.join(' ') + ';' +
                        getStyle(element).customStyles ?? ''
                    "
                    @input="enteredText($event)"
                  />
                  <span
                    class="absolute"
                    v-if="
                    (element.mandatory === true ||
                    element.mandatory === 1 ||
                    element.mandatory === 'true') &&
                    form_fields_info.hide_labels
                    "
                    :style="
                    'color: #ff0000; font-weight: bold; right: 16px;' +
                    'top:' + (getStyle(element).padding[0]) + 'px;' +
                    (getStyle(element).text.textAlign == 'right' ?
                    'left:' + (10) + 'px;' :
                    'right:' + (10) + 'px;' )
                    "
                  >*</span>
                </div>
                <div
                  v-if="formSubmitted && emailInvalid && element.name === 'email'"
                  class="text-danger text-sm mt-1 absolute email-error"
                >
                  {{ $t('frontend_groovemail_forms_view_email') }}
                </div>
              </div>
              <div
                v-if="element.type === 'textbox' && element.name === 'phone_number'"
                class="flex flex-col mb-4 relative"
                :style="
                  'margin: ' + getStyle(element).margin.join('px ') + 'px;' +
                  'color:' + getStyle(element).text.color + ';'
                "
              >
                <p
                  class="font-semibold text-sm mb-2"
                  v-if="!form_fields_info.hide_labels"
                  :style="
                    'text-align: ' + getStyle(element).text.textAlign + ';' +
                    'color: ' + getStyle(element).labelColor + ';'
                  "
                >
                  {{ element.placeholder }}
                  <span
                    v-if="
                      element.mandatory === true ||
                      element.mandatory === 1 ||
                      element.mandatory === 'true'
                    "
                    class="text-red font-bold"
                    >*</span
                  >
                </p>
                <div id="vue-phone" class="w-full rounded-lg" 
                  :class="{ 'form-phone-number-select-down': mainindex === 0, 'form-phone-number-select-top': mainindex > 0}"
                >
                  <VuePhoneNumberInput
                    :style="
                        'background:' + getStyle(element).backgroundColor + ';' +
                        'box-shadow:' + (getStyle(element).boxShadow ?? '') + ';' +
                        '--form-style-placeholder-color:' + getStyle(element).placeholderColor + ';' +
                        'font-family:' + (getStyle(element).text.fontFamily || '') + ';' +
                        'text-shadow:' + (getStyle(element).text.textShadow || '') + ';' +
                        'font-size:' + getStyle(element).text.fontSize + 'px;' +
                        'text-align:' + getStyle(element).text.textAlign + ';' +
                        'font-style:' + (getStyle(element).text.fontStyle || '') + ';' +
                        'font-weight:' + (getStyle(element).text.fontWeight || '') + ';' +
                        'letter-spacing:' + (getStyle(element).text.letterSpacing || '') + ';' +
                        'line-height:' + (getStyle(element).text.lineHeight || '') + ';' +
                        '-webkit-text-stroke-width:' + (getStyle(element).text.textStrokeWidth || '') + ';' +
                        '-webkit-text-stroke-color:' + (getStyle(element).text.textStrokeColor || '') + ';' +
                        'text-decoration-line:' + (getStyle(element).text.textDecorationLine || '') + ';' +
                        'color:' + getStyle(element).text.color + ';' +

                        'padding: ' + getStyle(element).padding.join('px ') + 'px;' +
                        'height:auto;' +
                        'border-width:' + getStyle(element).border?.width.join('px ') + 'px;' +
                        'border-radius:' + getStyle(element).border?.radius.join('px ') + 'px;' +
                        'border-color:' + getStyle(element).border?.color.join(' ') + ';' +
                        'border-style:' + getStyle(element).border?.style.join(' ') + ';' +
                        getStyle(element).customStyles ?? ''
                    "
                    :border-radius="6"
                    :fetch-country="true"
                    :show-code-on-list="true"
                    v-model="form_phone_number"
                    @update="getPhoneData($event)"
                  />
                </div>
                <div
                  v-if="formSubmitted && !phoneData.isValid && form_phone_number"
                  class="text-danger text-sm mt-1 mb-2 absolute email-error"
                >
                  <p>
                    {{ $t('frontend_groovemail_settings_integeration_invalid_phone_number') }}
                  </p>
                </div>
              </div>
              <div
                v-if="element.type === 'textarea'"
                class="flex flex-col mb-4 relative"
                :style="
                  'margin: ' + getStyle(element).margin.join('px ') + 'px;' +
                  'color:' + getStyle(element).text.color + ';'
                "
              >
                <p
                  class="font-semibold text-sm mb-2"
                  v-if="!form_fields_info.hide_labels"
                  :style="
                    'color:' + getStyle(element).labelColor + ';' +
                    'text-align: ' + getStyle(element).text.textAlign + ';'
                  ">
                  {{ element.placeholder }}
                  <span
                    v-if="
                      element.mandatory === true ||
                      element.mandatory === 1 ||
                      element.mandatory === 'true'
                    "
                    class="text-red font-bold"
                    >*</span
                  >
                </p>
                <div
                  class="w-full rounded-lg"
                >
                  <textarea
                    :style="
                        'background:' + getStyle(element).backgroundColor + ';' +
                        'box-shadow:' + (getStyle(element).boxShadow ?? '') + ';' +

                        '--form-style-placeholder-color:' + getStyle(element).placeholderColor + ';' +
                        'font-family:' + (getStyle(element).text.fontFamily || '') + ';' +
                        'text-shadow:' + (getStyle(element).text.textShadow || '') + ';' +
                        'font-size:' + getStyle(element).text.fontSize + 'px;' +
                        'text-align:' + getStyle(element).text.textAlign + ';' +
                        'font-style:' + (getStyle(element).text.fontStyle || '') + ';' +
                        'font-weight:' + (getStyle(element).text.fontWeight || '') + ';' +
                        'letter-spacing:' + (getStyle(element).text.letterSpacing || '') + ';' +
                        'line-height:' + (getStyle(element).text.lineHeight || '') + ';' +
                        '-webkit-text-stroke-width:' + (getStyle(element).text.textStrokeWidth || '') + ';' +
                        '-webkit-text-stroke-color:' + (getStyle(element).text.textStrokeColor || '') + ';' +
                        'text-decoration-line:' + (getStyle(element).text.textDecorationLine || '') + ';' +
                        'color:' + getStyle(element).text.color + ';' +

                        'padding: ' + getStyle(element).padding.join('px ') + 'px;' +
                        'height:auto;' +
                        'border-width:' + getStyle(element).border?.width.join('px ') + 'px;' +
                        'border-radius:' + getStyle(element).border?.radius.join('px ') + 'px;' +
                        'border-color:' + getStyle(element).border?.color.join(' ') + ';' +
                        'border-style:' + getStyle(element).border?.style.join(' ') + ';' +
                        getStyle(element).customStyles ?? ''
                    "
                    :id="
                      element.fieldtype === 'standard'
                        ? element.name + '_' + formid
                        : element.identifier + '_' + formid
                    "
                    @change="formAltered"
                    @input="formAltered"
                    rows="4"
                    class="px-3 py-2 rounded-lg w-full resize-none"
                    :placeholder="form_fields_info.hide_labels ? element.placeholder : ''"
                    :required="
                      element.mandatory === true ||
                      element.mandatory === 1 ||
                      element.mandatory === 'true'
                        ? true
                        : false
                    "
                    :name="
                      element.fieldtype === 'standard'
                        ? element.name
                        : element.identifier
                    "
                  ></textarea>
                </div>
              </div>
              <div
                v-if="element.type === 'dropdown'"
                class="flex w-full flex-col relative"
                :style="
                  'color:' + getStyle(element).text.color + ';'
                "
              >
                <div
                  class="flex flex-col text-left"
                  :style="
                    'margin: ' + getStyle(element).margin.join('px ') + 'px;' +
                    'text-align: ' + getStyle(element).text.textAlign + ';'
                  "
                >
                  <p
                    v-if="!form_fields_info.hide_labels"
                    class="font-semibold text-sm mb-2"
                    :style="'color: ' + getStyle(element).labelColor + ';'"
                  >
                    {{ element.label }}
                    <span
                      v-if="
                        element.mandatory === true ||
                        element.mandatory === 1 ||
                        element.mandatory === 'true'
                      "
                      class="text-red font-bold"
                      >*</span
                    >
                  </p>
                  <div class="relative">
                    <i class="absolute fa fa-caret-down" aria-hidden="true"></i>
                    <select
                      @change="formAltered"
                      :style="
                        'background:' + getStyle(element).backgroundColor + ';' +
                        'box-shadow:' + (getStyle(element).boxShadow ?? '') + ';' +

                        '--form-style-placeholder-color:' + getStyle(element).placeholderColor + ';' +
                        'font-family:' + (getStyle(element).text.fontFamily || '') + ';' +
                        'text-shadow:' + (getStyle(element).text.textShadow || '') + ';' +
                        'font-size:' + getStyle(element).text.fontSize + 'px;' +
                        'text-align:' + getStyle(element).text.textAlign + ';' +
                        'font-style:' + (getStyle(element).text.fontStyle || '') + ';' +
                        'font-weight:' + (getStyle(element).text.fontWeight || '') + ';' +
                        'letter-spacing:' + (getStyle(element).text.letterSpacing || '') + ';' +
                        'line-height:' + (getStyle(element).text.lineHeight || '') + ';' +
                        '-webkit-text-stroke-width:' + (getStyle(element).text.textStrokeWidth || '') + ';' +
                        '-webkit-text-stroke-color:' + (getStyle(element).text.textStrokeColor || '') + ';' +
                        'text-decoration-line:' + (getStyle(element).text.textDecorationLine || '') + ';' +
                        'color:' + getStyle(element).text.color + ';' +

                        'padding: ' + getStyle(element).padding.join('px ') + 'px;' +
                        'height:auto;' +
                        'border-width:' + getStyle(element).border?.width.join('px ') + 'px;' +
                        'border-radius:' + getStyle(element).border?.radius.join('px ') + 'px;' +
                        'border-color:' + getStyle(element).border?.color.join(' ') + ';' +
                        'border-style:' + getStyle(element).border?.style.join(' ') + ';' +
                        getStyle(element).customStyles ?? ''
                      "
                      class="w-full rounded-lg bg-white focus:outline-none"
                      :required="
                        element.mandatory === true ||
                        element.mandatory === 1 ||
                        element.mandatory === 'true'
                          ? true
                          : false
                      "
                      :name="
                        element.fieldtype === 'standard'
                          ? element.name
                          : element.identifier
                      "
                    >
                      <option
                        disabled
                        v-if="form_fields_info.hide_labels"
                        selected
                      >{{element.label}}</option>
                      <option
                        v-for="(option, index) in element.options"
                        :key="index"
                        :value="option"
                      >
                        {{ option }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div
                v-if="element.type === 'radio'"
                class="flex flex-col relative"
              >
                <div
                  class="w-full text-left"
                  :style="
                    'margin: ' + getStyle(element).margin.join('px ') + 'px;' +
                    'text-align: ' + getStyle(element).text.textAlign + ';' +
                    'color:' + getStyle(element).text.color + ';' +
                    getStyle(element).customStyles ?? ''
                  "
                >
                  <p
                    class="font-semibold text-sm"
                    :style="'color: ' + getStyle(element).labelColor + ';'"
                  >
                    {{ element.label }}
                    <span
                      v-if="
                        element.mandatory === true ||
                        element.mandatory === 1 ||
                        element.mandatory === 'true'
                      "
                      class="text-red font-bold"
                      >*</span
                    >
                  </p>
                  <div
                    :style="
                      'padding: ' + getStyle(element).padding.join('px ') + 'px;' +

                      'text-shadow:' + (getStyle(element).text.textShadow || '') + ';' +
                      'font-size:' + getStyle(element).text.fontSize + 'px;' +
                      'text-align:' + getStyle(element).text.textAlign + ';' +
                      'font-style:' + (getStyle(element).text.fontStyle || '') + ';' +
                      'font-weight:' + (getStyle(element).text.fontWeight || '') + ';' +
                      'letter-spacing:' + (getStyle(element).text.letterSpacing || '') + ';' +
                      'line-height:' + (getStyle(element).text.lineHeight || '') + ';' +
                      '-webkit-text-stroke-width:' + (getStyle(element).text.textStrokeWidth || '') + ';' +
                      '-webkit-text-stroke-color:' + (getStyle(element).text.textStrokeColor || '') + ';' +
                      'text-decoration-line:' + (getStyle(element).text.textDecorationLine || '') + ';' +
                      'color:' + getStyle(element).text.color + ';' +
                      getStyle(element).customStyles ?? ''
                    "
                  >
                    <div
                      v-for="(value, index) in element.options"
                      :key="index"
                      :style="
                        'justify-content: ' + getStyle(element).text.textAlign + ';'
                      "
                      class="mt-2 flex"
                    >
                      <label
                        class="radio-container mt-1 text-sm"
                      >
                        {{ value }}
                        <input
                          :id="
                            element.fieldtype === 'standard'
                              ? element.name + '_' + formid
                              : element.identifier + '_' + formid
                          "
                          @change="formAltered"
                          @input="formAltered"
                          type="radio"
                          :value="value"
                          class="w-6 h-6 mr-10"
                          :required="
                            element.mandatory === true ||
                            element.mandatory === 1 ||
                            element.mandatory === 'true'
                              ? true
                              : false
                          "
                          :name="
                            element.fieldtype === 'standard'
                              ? element.name
                              : element.identifier
                          "
                        />
                        <span
                          class="radio-checkmark"
                          :style="
                            '--form-style-color:' + getStyle(element).iconColor + ';' +
                            '--form-style-background:' + getStyle(element).backgroundColor"
                        ></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="element.type === 'checkbox'"
                class="flex flex-col relative"
              >
                <div
                  class="w-full text-left"
                  :style="
                    'margin: ' + getStyle(element).margin.join('px ') + 'px;' +
                    'text-align: ' + getStyle(element).text.textAlign + ';' +
                    'color:' + getStyle(element).text.color + ';' +
                    getStyle(element).customStyles ?? ''
                  "
                >
                  <p
                    class="font-semibold text-sm"
                    :style="'color: ' + getStyle(element).labelColor + ';'"
                  >
                    {{ element.label }}
                    <span
                      v-if="
                        element.mandatory === true ||
                        element.mandatory === 1 ||
                        element.mandatory === 'true'
                      "
                      class="text-red font-bold"
                      >*</span
                    >
                  </p>
                  <div
                    :style="
                      'padding: ' + getStyle(element).padding.join('px ') + 'px;' +
                      'color:' + getStyle(element).text.color + ';'
                    "
                  >
                    <div
                      v-for="(value, index) in element.options"
                      :key="index"
                      class="mt-2 flex"
                      :style="
                        'justify-content: ' + getStyle(element).text.textAlign + ';' +
                        'font-family:' + (getStyle(element).text.fontFamily || '') + ';' +
                        'text-shadow:' + (getStyle(element).text.textShadow || '') + ';' +
                        'font-size:' + getStyle(element).text.fontSize + 'px;' +
                        'text-align:' + getStyle(element).text.textAlign + ';' +
                        'font-style:' + (getStyle(element).text.fontStyle || '') + ';' +
                        'font-weight:' + (getStyle(element).text.fontWeight || '') + ';' +
                        'letter-spacing:' + (getStyle(element).text.letterSpacing || '') + ';' +
                        'line-height:' + (getStyle(element).text.lineHeight || '') + ';' +
                        '-webkit-text-stroke-width:' + (getStyle(element).text.textStrokeWidth || '') + ';' +
                        '-webkit-text-stroke-color:' + (getStyle(element).text.textStrokeColor || '') + ';' +
                        'text-decoration-line:' + (getStyle(element).text.textDecorationLine || '') + ';' +
                        'color:' + getStyle(element).text.color + ';' +
                        getStyle(element).customStyles ?? ''
                      "
                    >
                      <label class="container pt-1 text-sm" style="display: inline-block; width: auto;">
                        <div v-if="typeof value == 'string'">
                          {{ value}}
                        </div>
                        <div v-else>
                          <a
                            style="text-decoration: underline"
                            target="_blank"
                            :href="value.link"
                          >{{ value.text }}</a>
                        </div>
                        <input
                          :id="
                            element.fieldtype === 'standard'
                              ? element.name + '[]_' + formid
                              : element.identifier + '[]_' + formid
                          "
                          @change="formAltered"
                          @input="formAltered"
                          type="checkbox"
                          class="mr-10"
                          :value="value"
                          :required="
                            element.mandatory === true ||
                            element.mandatory === 1 ||
                            element.mandatory === 'true'
                              ? true
                              : false
                          "
                          :name="
                            element.fieldtype === 'standard'
                              ? element.name + '[]'
                              : element.identifier + '[]'
                          "
                        />
                        <span class="checkmark"
                          :style="
                            '--form-style-color:' + getStyle(element).iconColor + ';' +
                            '--form-style-background:' + getStyle(element).backgroundColor"
                        ></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="element.type === 'submit'"
                class="w-full flex items-end w-full h-full"
              >
                <div
                  class="relative flex w-full"
                  :class="{
                    'justify-start': formDetails.style.styles.button.alignment == 'left',
                    'justify-end': formDetails.style.styles.button.alignment == 'right',
                    'justify-center': formDetails.style.styles.button.alignment == 'center',
                    'mb-4': form_fields_info.layout_type == 'horizontal'
                  }"
                >
                  <button
                    :style="
                        'height: auto;' +
                        'background:' + formDetails.style.styles.button.backgroundColor + ';' +
                        'box-shadow:' + (formDetails.style.styles.button.boxShadow ?? '') + ';' +
                        'margin:' + formDetails.style.styles.button.margin + 'px;' +
                        'padding: ' + formDetails.style.styles.button.padding.join('px ') + 'px;' +
                        'margin: ' + formDetails.style.styles.button.margin.join('px ') + 'px;' +
                        'border-width:' + formDetails.style.styles.button.border?.width.join('px ') + 'px;' +
                        'border-radius:' + formDetails.style.styles.button.border?.radius.join('px ') + 'px;' +
                        'border-color:' + formDetails.style.styles.button.border?.color.join(' ') + ';' +
                        'border-style:' + formDetails.style.styles.button.border?.style.join(' ') + ';' +
                        'font-family:' + (formDetails.style.styles.button.text.fontFamily || '') + ';' +
                        'text-shadow:' + (formDetails.style.styles.button.text.textShadow || '') + ';' +
                        'font-size:' + formDetails.style.styles.button.text.fontSize + 'px;' +
                        'text-align:' + formDetails.style.styles.button.text.textAlign + ';' +
                        'font-style:' + (formDetails.style.styles.button.text.fontStyle || '') + ';' +
                        'font-weight:' + (formDetails.style.styles.button.text.fontWeight || '') + ';' +
                        'letter-spacing:' + (formDetails.style.styles.button.text.letterSpacing || '') + ';' +
                        'line-height:' + (formDetails.style.styles.button.text.lineHeight || '') + ';' +
                        '-webkit-text-stroke-width:' + (formDetails.style.styles.button.text.textStrokeWidth || '') + ';' +
                        '-webkit-text-stroke-color:' + (formDetails.style.styles.button.text.textStrokeColor || '') + ';' +
                        'text-decoration-line:' + (formDetails.style.styles.button.text.textDecorationLine || '') + ';' +
                        'color:' + formDetails.style.styles.button.text.color + ';' +
                        formDetails.style.styles.button.customStyles ?? ''
                    "
                    class="send-btn border rounded-md text-white mt-3"
                    size="auto"
                    v-bind:class="{
                      'w-full': formDetails.style.styles.button.alignment == 'full',
                      'cursor-not-allowed': submitBtnDisabled,
                      'cursor-pointer': !submitBtnDisabled,
                    }"
                    @click="savedata($event)"
                  >
                    <div class="inline-block w-full">
                      <div>
                        {{
                          formDetails.form_submit_button_text
                            ? formDetails.form_submit_button_text
                            : $t('frontend_send')
                        }}
                      </div>
                      <div
                        :style="
                          'margin:' + formDetails.style.styles.button_sublabel.margin + 'px;' +
                          'padding: ' + formDetails.style.styles.button_sublabel.padding.join('px ') + 'px;' +
                          'margin: ' + formDetails.style.styles.button_sublabel.margin.join('px ') + 'px;' +
                          'font-family:' + (formDetails.style.styles.button_sublabel.text.fontFamily || '') + ';' +
                          'text-shadow:' + (formDetails.style.styles.button_sublabel.text.textShadow || '') + ';' +
                          'font-size:' + formDetails.style.styles.button_sublabel.text.fontSize + 'px;' +
                          'text-align:' + formDetails.style.styles.button_sublabel.text.textAlign + ';' +
                          'font-style:' + (formDetails.style.styles.button_sublabel.text.fontStyle || '') + ';' +
                          'font-weight:' + (formDetails.style.styles.button_sublabel.text.fontWeight || '') + ';' +
                          'letter-spacing:' + (formDetails.style.styles.button_sublabel.text.letterSpacing || '') + ';' +
                          'line-height:' + (formDetails.style.styles.button_sublabel.text.lineHeight || '') + ';' +
                          '-webkit-text-stroke-width:' + (formDetails.style.styles.button_sublabel.text.textStrokeWidth || '') + ';' +
                          '-webkit-text-stroke-color:' + (formDetails.style.styles.button_sublabel.text.textStrokeColor || '') + ';' +
                          'text-decoration-line:' + (formDetails.style.styles.button_sublabel.text.textDecorationLine || '') + ';' +
                          'color:' + formDetails.style.styles.button_sublabel.text.color + ';' +
                          formDetails.style.styles.button_sublabel.customStyles ?? ''
                        "
                        class="block"
                        v-if="form_fields_info.button_sublabel"
                      >
                        {{ form_fields_info.button_sublabel }}
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="formDetails.style.styles.form.backgroundPattern+'-pattern'" class="pattern-background"></div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import VuePhoneNumberInput from 'vue-phone-number-input';

import themeConfig from '@/theme/themeConfig.js';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

import createKey from '@/components/createHiddenKey.js';
import showAlert from '@/components/sweet-alert-popup.js';

// import icons
import CalenderIcon from '@/assets/images/icons/new/calendar_days_new.svg';

import DateTimePicker from '@groovepages/gd-ui-kit/components/DateTimePicker';

const serialize = require('form-serialize');

export default {
  layout: 'iframeLayout',
  components: {
    VuePhoneNumberInput,
    DateTimePicker,
    CalenderIcon,
  },

  data() {
    return {
      urlParameters: {},
      form_phone_number: '',
      phoneData: {
        countryCallingCode: '44',
        countryCode: 'GB',
        isValid: true,
      },
      submitBtnDisabled: true,
      hiddenKey: '',
      apiUrl: '',
      appUrl: '',
      permalink: '',
      variation: '',
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      formId: '',
      ipaddress: false,
      form_fields_info: null,
      form_fields: null,
      formSubmitted: false,
      emailInvalid: true,
      formDetails: '',
      reg: /^[_a-zA-Z0-9-]+(.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(.[a-zA-Z0-9-]+)*(.[a-zA-Z]{2,4})$/,
    };
  },

  async created() {
    // if(this.$route.query.grooveParentUrl){
    //   let url = new URL(this.$route.query.grooveParentUrl);
    //   this.urlParameters = Object.fromEntries(url.searchParams);
    // }
    const url = new URL(window.location.href);

    this.permalink = url.pathname.split('/').pop();
    this.variation = url.searchParams.get('variation') ?? 'default';

    this.hiddenKey = createKey(8);
    this.formSubmitted = false;
    this.apiUrl = window.config.apiUrl;

    this.appUrl = window.config.grooveappsurl;

    this.showLoader();
    this.formid = window.atob(this.permalink);

    const formData = await axios.get(`/optinform/${this.formid}?variation=${this.variation}`);
    const form = (this.formDetails = formData.data);
    this.form_fields_info = JSON.parse(form.form_fields);
    if(!this.form_fields_info.fields){
      this.form_fields_info.fields = JSON.parse(form.form_fields);
      this.form_fields_info.fields.push({"fieldtype":"submit","type":"submit","id":"submit"});
      this.form_fields_info.layout_type = 'vertical';
    }
    this.form_fields = this.form_fields_info.fields;

    this.hideLoader();

    this.$nextTick(function () {
      this.setUpPhoneNumberStyles();
    });

    const setindex = 1;
    this.$matomo &&
      this.$matomo.setCustomVariable(setindex, 'forms', this.formid, 'visit');

    this.$matomo &&
      this.$matomo.trackEvent('Forms', 'Form Load', 'form-view', this.formid);


    this.$nextTick(() => {
      document.getElementById('saveform').addEventListener(
        'submit',
        (e) => {
          e.preventDefault();
        },
        false
      );
    });
  },

  computed: {
    rows() {
      if(this.form_fields_info.layout_type !== 'custom'){
        return [
          [
            { width: 100, fields: this.form_fields_info.fields }
          ]
        ];
      }
          const form_fields = this.form_fields_info;
          const fields_on_rows = [...form_fields.rows.map((i) => i.map((e) => e.fields)).flat(2)];
          if(fields_on_rows.length !== form_fields.fields.length){
            form_fields.fields.forEach(i => {
              if(!fields_on_rows.find(f => f === i.id)){
                form_fields.rows[form_fields.rows.length - 1][0].fields.push(i.id);
              }
            });
          }
          return form_fields.rows.map(
            a => a.map(
              e => {
                e.fields = e.fields.map(
                  o => {
                    return form_fields.fields.find(
                      f => f.id === o
                    );
                  });
                e.fields = e.fields.filter(
                  o => o !== undefined
                );
                return e;
              }
            )
          );
    },
  },
  methods: {
    setUpPhoneNumberStyles() {
      const wrapper = document.querySelector('#MazPhoneNumberInput');
      if (!wrapper) {
        return;
      }
      const wrapperStyles = wrapper.getAttribute('style');
      const wrapperComputedStyles = window.getComputedStyle(wrapper);

      // Phone Number
      const phoneNumberInput = document.querySelector('#MazPhoneNumberInput .input-tel__input');
      phoneNumberInput.setAttribute('style', wrapperStyles + ';padding: 0; border:0; margin:0; border-radius: 0; background: none;');

      const phoneNumberContainer = document.querySelector('#MazPhoneNumberInput  .flex-1');
      phoneNumberContainer.setAttribute('style', wrapperStyles + '; display: flex; align-items: center; padding-top: 0; padding-bottom:0; border-left:0; border-bottom-left-radius: 0; border-top-left-radius: 0;');
      phoneNumberContainer.style.height = Number((wrapperComputedStyles.fontSize.replace('px', '')*1.5))
        + Number(wrapperComputedStyles.paddingTop.replace('px', ''))
        + Number(wrapperComputedStyles.paddingBottom.replace('px', ''))
        + Number(wrapperComputedStyles.borderTopWidth.replace('px', ''))
        + Number(wrapperComputedStyles.borderBottomWidth.replace('px', ''))
        +'px';

      // Country Selector
      const countrySelectorInput = document.querySelector('#MazPhoneNumberInput .country-selector__input');
      countrySelectorInput.setAttribute('style', wrapperStyles + '; padding: 0; border:0; margin:0; padding-left:40px; border-radius: 0; padding-top: 14px; background: none;');

      const selectCountryContainer = document.querySelector('#MazPhoneNumberInput  .select-country-container');
      selectCountryContainer.setAttribute('style', wrapperStyles + '; display: flex; align-items: center; padding: 0; border-bottom-right-radius: 0; border-top-right-radius: 0;');
      selectCountryContainer.style.height = Number((wrapperComputedStyles.fontSize.replace('px', '')*1.5))
        + Number(wrapperComputedStyles.paddingTop.replace('px', ''))
        + Number(wrapperComputedStyles.paddingBottom.replace('px', ''))
        + Number(wrapperComputedStyles.borderTopWidth.replace('px', ''))
        + Number(wrapperComputedStyles.borderBottomWidth.replace('px', ''))
        +'px';

      // Classes for color
      const style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = `.phoneInputColor { color: ${countrySelectorInput.style.color}!important; fill: ${countrySelectorInput.style.color}!important; }`;
      document.getElementsByTagName('head')[0].appendChild(style);

      // Country Code Text
      const countryCodeText = document.querySelector('#MazPhoneNumberInput label.country-selector__label');
      countryCodeText.classList.add('phoneInputColor');

      // Phone Input Example
      const phoneNumberExample = document.querySelector('#MazPhoneNumberInput label.input-tel__label');
      phoneNumberExample.classList.add('phoneInputColor');

      // Caret
      const countryCodeCaret = document.querySelector('#MazPhoneNumberInput svg .arrow');
      countryCodeCaret.classList.add('phoneInputColor');

      // Clean Styles
      wrapper.setAttribute('style', '');
    },
    getValue(element, value = ''){
      if(element.type === 'checkbox'){
        return this.urlParameters[element.identifier+'['+value+']'] === 'checked' || this.urlParameters[element.identifier+'['+value.text+']'] === 'checked';
      }
      if(element.fieldtype === 'standard'){
        return this.urlParameters[element.name] ?? '';
      }
      return this.urlParameters[element.identifier] ?? '';
    },
    getStyle(element){
      let type = element.type;
      let id = element.id
      if (type === 'paragraph') {
        type = 'paragraphs';
      }
      if (!['paragraph', 'heading', 'subheading'].includes(element.type)) {
        type = 'field';
      }
      let advancedStyles = {};
      if(
        this.formDetails.style.styles.advanced &&
        this.formDetails.style.styles.advanced.fields &&
        this.formDetails.style.styles.advanced.fields[id]
      ){
        advancedStyles = this.formDetails.style.styles.advanced.fields[id];
      }

      return {...this.formDetails.style.styles[type], ...advancedStyles};
    },
    getPhoneData(event) {
      if (event.countryCallingCode) {
        this.phoneData.countryCallingCode = event.countryCallingCode;
      }
      if (event.countryCode) {
        this.phoneData.countryCode = event.countryCode;
      }
      this.phoneData.isValid = event.isValid;
      if (event.phoneNumber && event.isValid) {
        this.submitBtnDisabled = false;
      } else {
        this.submitBtnDisabled = true;
      }
    },

    formAltered() {
      const formObj = serialize(document.querySelector('#saveform'), {
        hash: true,
      });
      let formValid = true;
      for (let i = 0; i < this.form_fields.length; i += 1) {
        if (
          this.form_fields[i].name != 'phone_number' &&
          (this.form_fields[i].mandatory === 1 ||
            this.form_fields[i].mandatory === true ||
            this.form_fields[i].mandatory === 'true')
        ) {
          if (this.form_fields[i].name) {
            if (!formObj.hasOwnProperty(this.form_fields[i].name)) {
              formValid = false;
              break;
            }
          } else if (this.form_fields[i].identifier) {
            if (!formObj.hasOwnProperty(this.form_fields[i].identifier)) {
              formValid = false;
              break;
            }
          }
        } else if (
          this.form_fields[i].name === 'phone_number' &&
          (this.form_fields[i].mandatory === 1 ||
            this.form_fields[i].mandatory === true ||
            this.form_fields[i].mandatory === 'true')
        ) {
          if (this.phoneData.isValid && this.form_phone_number) {
            formValid = true;
          } else {
            formValid = false;
            break;
          }
        } else if (
          this.form_fields[i].name === 'phone_number' &&
          !(
            this.form_fields[i].mandatory === 1 ||
            this.form_fields[i].mandatory === true ||
            this.form_fields[i].mandatory === 'true'
          )
        ) {
          formValid = true;
        }
      }
      if (formValid && !this.emailInvalid) {
        this.submitBtnDisabled = false;
      } else {
        this.submitBtnDisabled = true;
      }
    },

    enteredText(e) {
      this.formAltered();
      if (e.target.name === 'email') {
        this.emailInvalid =
          e.target.value === ''
            ? false
            : !this.reg.test(e.target.value);
      }
    },

    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },


    // error message for the request field
    async requestErrorAlert(error) {
      // hide the loader
      this.hideLoader();
      
      await showAlert({
        iconType: 'alert-error',
        html : `
          <style>.swal2-cancel { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
          <p class="text-sm text-deep-dark mb-3">${error || this.$t('frontend_backend_error') }</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close'),
      });
    },

    // success message for the request field
    async requestSuccessAlert(successMessage) {
      // hide the loader
      this.hideLoader();
      
      await showAlert({
        iconType: 'alert-success',
        html : `
          <style>.swal2-confirm { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
          <p class="text-sm text-deep-dark mb-3">${successMessage}</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close'),
      });
    },

    sendMessageToParent(msg) {
      window.parent.postMessage(msg, '*');
    },

    savedata() {
      this.formSubmitted = true;

      if(this.emailInvalid || this.submitBtnDisabled) {
        return;
      }

      const form = document.querySelector('#saveform');
      const obj = serialize(form, { hash: true });
      if (!obj.hasOwnProperty(this.hiddenKey)) {
        obj[this.hiddenKey] = '';
      }
      let formValid = true;
      for (let i = 0; i < this.form_fields.length; i += 1) {
        if (
          this.form_fields[i].name !== 'phone_number' &&
          (this.form_fields[i].mandatory === 1 ||
            this.form_fields[i].mandatory === true ||
            this.form_fields[i].mandatory === 'true')
        ) {
          if (this.form_fields[i].name) {
            if (!obj.hasOwnProperty(this.form_fields[i].name)) {
              formValid = false;
              break;
            }
          } else if (this.form_fields[i].identifier) {
            if (!obj.hasOwnProperty(this.form_fields[i].identifier)) {
              formValid = false;
              break;
            }
          }
        } else if (
          this.form_fields[i].name === 'phone_number' &&
          (this.form_fields[i].mandatory === 1 ||
            this.form_fields[i].mandatory === true ||
            this.form_fields[i].mandatory === 'true')
        ) {
          if (this.phoneData.isValid && this.form_phone_number) {
            formValid = true;
            obj[this.form_fields[i].name] = this.form_phone_number;
            obj.phone_country_code_data = {
              code: `+${  this.phoneData.countryCallingCode}`,
              symbol: this.phoneData.countryCode,
            };
          } else {
            formValid = false;
            break;
          }
        } else if (
          this.form_fields[i].name === 'phone_number' &&
          !(
            this.form_fields[i].mandatory === 1 ||
            this.form_fields[i].mandatory === true ||
            this.form_fields[i].mandatory === 'true'
          )
        ) {
          formValid = true;
          obj[this.form_fields[i].name] = this.form_phone_number;
          obj.phone_country_code_data = {
            code: `+${  this.phoneData.countryCallingCode}`,
            symbol: this.phoneData.countryCode,
          };
        }
      }
      if (formValid) {
        this.showLoader();
        const self = this;
        const formData = new FormData(document.querySelector('#saveform'));
        if (obj.hasOwnProperty('phone_country_code_data')) {
          formData.append(
            'phone_country_code_data',
            JSON.stringify(obj.phone_country_code_data)
          );
        }
        if (obj.hasOwnProperty('phone_number')) {
          formData.append('phone_number', obj.phone_number);
        }
        axios
          .post(`${this.apiUrl  }/saverawuserdetails`, formData)
          .then(async (resp) => {
            if (resp.data.status === 'success') {
              if (resp.data.redirect_url) {
                const thankYouPage = resp.data.redirect_url;
                const successObj = {
                  type: 'groovemail-successful-submission',
                  redirect: thankYouPage,
                };
                const successJSON = JSON.stringify(successObj);
                self.sendMessageToParent(successJSON);
                this.hideLoader();
              } else {
                // show success message
                this.requestSuccessAlert(this.$t('frontend_groovemail_forms_view_confirm_email'));
              }
            } else if (resp.data.status === 'success_no_redirect') {
              // show success message
              this.requestSuccessAlert(this.$t('frontend_groovemail_forms_view_confirm_email'));

            } else if (resp.data.status === 'error' && resp.data.error === 'Invalid data.') {
              // show error message
              this.requestErrorAlert(this.$t('frontend_groovemail_forms_view_invalid_data'));
            }
          })
          .catch(async () => {
            // show error message
            this.requestErrorAlert(this.$t('frontend_groovemail_forms_view_unknown_backend_error'));
          });
      }
    },
  },
};
</script>

<style lang="scss">
// import brand colors variables
@import url('https://assets.grooveapps.com/css/main.css');

.form-wrapper {
  border-radius: 4px;

  .email-error {
    top: 70px;
  }

  .send-btn,
  .send-btn:focus,
  .send-btn:hover {
    border-radius: 6px;
    background-color: #2f80ed;
    color: #fff;
    border-color: #2f80ed;
    &:hover {
      background-color: #2f80ed;
      opacity: 2;
    }
  }

  .mr-10 {
    margin-right: 10px;
  }

  .fa-caret-down {
    top: 12px;
    right: 12px;
    color: #989ab2;
  }

  
  select {
    color: #545671;
    -webkit-appearance: none;
    appearance: none;

    &::-ms-expand {
      display: none;
    }
  }

  /* The container */
  .container {
    display: block;
    position: relative;
    padding-left: 35px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 24px;
    width: 24px;
    background-color: #fff;
    border: solid 1px #d5d8e5;
    border-radius: 4px;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .container .checkmark:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  // ----------------------------- //
  .radio-container {
    display: block;
    position: relative;
    padding-left: 35px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }

  /* Hide the browser's default radio button */
  .radio-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  /* Create a custom radio button */
  .radio-checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 24px;
    width: 24px;
    background-color: #fff;
    border: solid 1px #d5d8e5;
    border-radius: 50%;
  }

  /* On mouse-over, add a grey background color */
  .radio-container:hover input ~ .radio-checkmark {
    background-color: #fff;
    border: solid 1px #d5d8e5;
  }

  /* Create the indicator (the dot/circle - hidden when not checked) */
  .radio-checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  /* Show the indicator (dot/circle) when checked */
  .radio-container input:checked ~ .radio-checkmark:after {
    display: block;
  }

  /* Style the indicator (dot/circle) */
  .radio-container .radio-checkmark:after {
    top: 3px;
    left: 3px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
  }

  .form-phone-number-select-top {
    .country-selector__list.has-calling-code {
      max-height: 140px !important;
      bottom: 100% !important;
      top: unset !important;
    }
  }

  .form-phone-number-select-down {
    .country-selector__list.has-calling-code {
      max-height: 140px !important;
      bottom: unset !important;
      top: 100% !important;
    }
  }
}
.groovemail-form-preset .container input:checked ~ .checkmark {
  background-color: var(--form-style-background)!important;
  border: solid 1px var(--form-style-color)!important;
}
.groovemail-form-preset .container .checkmark:after {
  border-color: var(--form-style-color)!important;
}

.groovemail-form-preset .radio-container input:checked ~ .radio-checkmark {
  background-color: var(--form-style-background)!important;
  border: solid 1px var(--form-style-color)!important;
}
.groovemail-form-preset .radio-container .radio-checkmark:after {
  background: var(--form-style-color)!important;
}
.groovemail-form-preset input::placeholder, .groovemail-form-preset textarea::placeholder {
  color: var(--form-style-placeholder-color)!important;
}

#vue-phone {
  .input-tel__input{
    transition-duration: 0s;
    height: auto;
    min-height: auto;
  }
  .country-selector__input, .country-selector{
    height: auto;
    min-height: auto;
  }
  .country-selector__country-flag {
    top:18px;
  }
  .input-phone-number {
    width: 100%;
    height: auto;
    min-height: auto;
  }
  input {
    box-shadow: none!important;
  }
  .input-tel.has-hint input, .input-tel.has-value input{
    padding-top: 14px!important;
  }
  .input-tel label {
    left: 0px;
    width: 100%;
  }
  label{
    line-height: 12px;
    top: 0px;
  }
  .has-value label {
    opacity: 0.8!important;
  }
}
.groovemail-form-preset {
  input, textarea {
    outline: none!important;
  }
}

.form-wrapper > * {
  z-index: 15;
}
.pattern-background {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 12;
}

/* Patterns */
.Wavy-pattern {
    background-color: var(--gp-bg-back-color) !important;
    opacity: var(--gp-bg-opacity);
    background-image: repeating-radial-gradient(circle at 0 0, transparent 0, var(--gp-bg-back-color) var(--gp-bg-spacing)), repeating-linear-gradient(var(--gp-bg-front-alpha-color), var(--gp-bg-front-color)) !important;
}

.Rhombus-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-image: linear-gradient(135deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, transparent 25%), linear-gradient(225deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, transparent 25%), linear-gradient(45deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, transparent 25%), linear-gradient(315deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, var(--gp-bg-back-color, white) 25%) !important;
    background-position: var(--gp-bg-spacing) 0, var(--gp-bg-spacing) 0, 0 0, 0 0 !important;
    background-size: var(--gp-bg-spacing) var(--gp-bg-spacing) !important;
}

.ZigZag-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-image: linear-gradient(135deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, transparent 25%), linear-gradient(225deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, transparent 25%), linear-gradient(45deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, transparent 25%), linear-gradient(315deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, var(--gp-bg-back-color, white) 25%);
    background-position: var(--gp-bg-spacing) 0, var(--gp-bg-spacing) 0, 0 0, 0 0;
    background-size: calc(var(--gp-bg-spacing) * 2) calc(var(--gp-bg-spacing) * 2);
    background-repeat: repeat;
}

.ZigZag3d-pattern {
    background: linear-gradient(135deg, var(--gp-bg-front-alpha-color, rgba(228, 63, 112, 0.3333)) 25%, transparent 25%) -var(--gp-bg-spacing) 0/ calc(var(--gp-bg-spacing) * 2) calc(var(--gp-bg-spacing) * 2), linear-gradient(225deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, transparent 25%) -var(--gp-bg-spacing) 0/ calc(var(--gp-bg-spacing) * 2) calc(var(--gp-bg-spacing) * 2), linear-gradient(315deg, var(--gp-bg-front-alpha-color, rgba(228, 63, 112, 0.3333)) 25%, transparent 25%) 0px 0/ calc(var(--gp-bg-spacing) * 2) calc(var(--gp-bg-spacing) * 2), linear-gradient(45deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, var(--gp-bg-back-color, white) 25%) 0px 0/ calc(var(--gp-bg-spacing) * 2) calc(var(--gp-bg-spacing) * 2) !important;
    background-color: var(--gp-bg-back-color, white) !important;
    background-size: calc(var(--gp-bg-spacing) * 2) calc(var(--gp-bg-spacing) * 2) !important;

}

.Moon-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-image: radial-gradient(ellipse farthest-corner at var(--gp-bg-spacing) var(--gp-bg-spacing), var(--gp-bg-front-color, rgba(228, 63, 112, 1)), var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 50%, var(--gp-bg-back-color, white) 50%);
    background-size: var(--gp-bg-spacing) var(--gp-bg-spacing);
}

.Circles-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-image: radial-gradient(circle at center center, var(--gp-bg-front-color, rgba(228, 63, 112, 1)), var(--gp-bg-back-color, white)), repeating-radial-gradient(circle at center center, var(--gp-bg-front-color, rgba(228, 63, 112, 1)), var(--gp-bg-front-color, rgba(228, 63, 112, 1)), var(--gp-bg-spacing), transparent calc(var(--gp-bg-spacing) * 2), transparent var(--gp-bg-spacing));
    background-blend-mode: multiply;
}

.Diagonal-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-image: repeating-linear-gradient(45deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)), var(--gp-bg-front-color, rgba(228, 63, 112, 1)) var(--gp-bg-spacing), var(--gp-bg-back-color, white) var(--gp-bg-spacing), var(--gp-bg-back-color, white) calc(var(--gp-bg-spacing) * 5));
}

.Diagonalv2-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-image: repeating-linear-gradient(-45deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)), var(--gp-bg-front-color, rgba(228, 63, 112, 1)) var(--gp-bg-spacing), var(--gp-bg-back-color, white) var(--gp-bg-spacing), var(--gp-bg-back-color, white) calc(var(--gp-bg-spacing) * 5));
}

.Diagonalv3-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-size: var(--gp-bg-spacing) var(--gp-bg-spacing) !important;
    background-image: repeating-linear-gradient(45deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 0, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) calc(var(--gp-bg-spacing) / 10), var(--gp-bg-back-color, white) 0, var(--gp-bg-back-color, white) 50%);
}

.Paper-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-position: -calc(var(--gp-bg-spacing) / 5) -calc(var(--gp-bg-spacing) / 5), -calc(var(--gp-bg-spacing) / 5) -calc(var(--gp-bg-spacing) / 5), -calc(var(--gp-bg-spacing) / 10) -calc(var(--gp-bg-spacing) / 10), -calc(var(--gp-bg-spacing) / 10) -calc(var(--gp-bg-spacing) / 10);
    background-size: calc(var(--gp-bg-spacing) * 5) calc(var(--gp-bg-spacing) * 5), calc(var(--gp-bg-spacing) * 5) calc(var(--gp-bg-spacing) * 5), var(--gp-bg-spacing) var(--gp-bg-spacing), var(--gp-bg-spacing) var(--gp-bg-spacing);
    background-image: linear-gradient(var(--gp-bg-front-color, rgba(228, 63, 112, 1)) calc(var(--gp-bg-spacing) / 5), transparent calc(var(--gp-bg-spacing) / 5)), linear-gradient(90deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) calc(var(--gp-bg-spacing) / 5), transparent calc(var(--gp-bg-spacing) / 5)), linear-gradient(var(--gp-bg-front-color, rgba(228, 63, 112, 1)) calc(var(--gp-bg-spacing) / 10), transparent calc(var(--gp-bg-spacing) / 10)), linear-gradient(90deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) calc(var(--gp-bg-spacing) / 10), var(--gp-bg-back-color, white) calc(var(--gp-bg-spacing) / 10));
}

.Isometric-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-position: 0 0, 0 0, calc(var(--gp-bg-spacing) * 4)  calc(var(--gp-bg-spacing) * 7), calc(var(--gp-bg-spacing) * 4)  calc(var(--gp-bg-spacing) * 7), 0 0, calc(var(--gp-bg-spacing) * 4) calc(var(--gp-bg-spacing) * 7);
    background-size: calc(var(--gp-bg-spacing) * 8) calc(var(--gp-bg-spacing) * 14);
    background-image: linear-gradient(30deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 12%, transparent 12.5%, transparent 87%, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 87.5%, var(--gp-bg-front-color, rgba(228, 63, 112, 1))), linear-gradient(150deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 12%, transparent 12.5%, transparent 87%, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 87.5%, var(--gp-bg-front-color, rgba(228, 63, 112, 1))), linear-gradient(30deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 12%, transparent 12.5%, transparent 87%, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 87.5%, var(--gp-bg-front-color, rgba(228, 63, 112, 1))), linear-gradient(150deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 12%, transparent 12.5%, transparent 87%, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 87.5%, var(--gp-bg-front-color, rgba(228, 63, 112, 1))), linear-gradient(60deg, var(--gp-bg-front-alpha-color, rgba(228, 63, 112, 0.3333)) 25%, transparent 25.5%, transparent 75%, var(--gp-bg-front-alpha-color, rgba(228, 63, 112, 0.3333)) 75%, var(--gp-bg-front-alpha-color, rgba(228, 63, 112, 0.3333))), linear-gradient(60deg, var(--gp-bg-front-alpha-color, rgba(228, 63, 112, 0.3333)) 25%, transparent 25.5%, transparent 75%, var(--gp-bg-front-alpha-color, rgba(228, 63, 112, 0.3333)) 75%, var(--gp-bg-front-alpha-color, rgba(228, 63, 112, 0.3333)));
}

.Polka-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-size: var(--gp-bg-spacing) var(--gp-bg-spacing);
    background-image: radial-gradient(var(--gp-bg-front-color, rgba(228, 63, 112, 1)) calc(var(--gp-bg-spacing) / 20), var(--gp-bg-back-color, white) calc(var(--gp-bg-spacing) / 20));
}

.Polkav2-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-position: 0 0, var(--gp-bg-spacing) var(--gp-bg-spacing);
    background-size: calc(var(--gp-bg-spacing) * 2) calc(var(--gp-bg-spacing) * 2);
    background-image: radial-gradient(var(--gp-bg-front-color, rgba(228, 63, 112, 1)) calc(var(--gp-bg-spacing) / 20), transparent calc(var(--gp-bg-spacing) / 20)), radial-gradient(var(--gp-bg-front-color, rgba(228, 63, 112, 1)) calc(var(--gp-bg-spacing) / 20), var(--gp-bg-back-color, white) calc(var(--gp-bg-spacing) / 20));
}

.Lines-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-size: var(--gp-bg-spacing) var(--gp-bg-spacing);
    background-image: linear-gradient(0deg, var(--gp-bg-back-color, white) 50%, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 50%);
}

.Linesv2-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-size: var(--gp-bg-spacing) 100%;
    background-image: linear-gradient(to right, var(--gp-bg-front-color, rgba(228, 63, 112, 1)), var(--gp-bg-front-color, rgba(228, 63, 112, 1)) calc(var(--gp-bg-spacing) / 2), var(--gp-bg-back-color, white) calc(var(--gp-bg-spacing) / 2), var(--gp-bg-back-color, white));
}

.Linesv3-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-size: calc(var(--gp-bg-spacing) * 2) calc(var(--gp-bg-spacing) * 2);
    background-image: repeating-linear-gradient(0deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)), var(--gp-bg-front-color, rgba(228, 63, 112, 1)) calc(var(--gp-bg-spacing) / 10), var(--gp-bg-back-color, white) calc(var(--gp-bg-spacing) / 10), var(--gp-bg-back-color, white));
}

.Linesv4-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-size: calc(var(--gp-bg-spacing) * 2) calc(var(--gp-bg-spacing) * 2);
    background-image: repeating-linear-gradient(to right, var(--gp-bg-front-color, rgba(228, 63, 112, 1)), var(--gp-bg-front-color, rgba(228, 63, 112, 1)) calc(var(--gp-bg-spacing) / 10), var(--gp-bg-back-color, white) calc(var(--gp-bg-spacing) / 10), var(--gp-bg-back-color, white));
}

.Triangle-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-size: var(--gp-bg-spacing) var(--gp-bg-spacing);
    background-image: linear-gradient(45deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 50%, var(--gp-bg-back-color, white) 50%);
}

.Trianglev2-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-size: var(--gp-bg-spacing) var(--gp-bg-spacing);
    background-image: linear-gradient(-45deg, var(--gp-bg-back-color, white), var(--gp-bg-back-color, white) 50%, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 50%, var(--gp-bg-front-color, rgba(228, 63, 112, 1)));
}

.Rectangle-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-position: 0 0, var(--gp-bg-spacing) var(--gp-bg-spacing) !important;
    background-size: calc(var(--gp-bg-spacing) * 2) calc(var(--gp-bg-spacing) * 2) !important;
    background-image: repeating-linear-gradient(45deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, transparent 25%, transparent 75%, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 75%, var(--gp-bg-front-color, rgba(228, 63, 112, 1))), repeating-linear-gradient(45deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, var(--gp-bg-back-color, white) 25%, var(--gp-bg-back-color, white) 75%, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 75%, var(--gp-bg-front-color, rgba(228, 63, 112, 1))) !important;
}
.vld-overlay {
  text-align: center;
  svg {
    display: inline-block;
    background: #ffffffc9;
    border-radius: 50px;
    padding: 5px;
  }
}
</style>